import { __ } from "@wordpress/i18n";
import { addFilter } from "@wordpress/hooks";
import Button from "../button/button";
import { Heading, Row, P } from "../../ui/style";
import { MediaUpload, MediaUploadCheck } from "@wordpress/media-utils";
import { useStateValue } from "../../store/store";
import React, { useState } from "react";
import sendPostMessage from "../../components/site-preview/utils";
import { RangeControl } from "@wordpress/components";
import styled from 'styled-components';

import './style.scss';

import { initialState } from '../../store/reducer'

function MediaUploader() {
    const replaceMediaUpload = () => MediaUpload;
    const [{ siteLogo }, dispatch] = useStateValue();

    addFilter(
        "editor.MediaUpload",
        "core/edit-post/components/media-upload/replace-media-upload",
        replaceMediaUpload
    );

    const onSelectImage = (media) => {
        let mediaData = {
            id: media.id,
            url: media.url,
            width: siteLogo.width,
        };

        updateValues(mediaData);
    };

    const updateValues = (data) => {
        dispatch({
            type: "set",
            siteLogo: data,
        });

        sendPostMessage({
            param: "siteLogo",
            data: data,
        });
    };

    const onRemoveImage = () => {
        updateValues(initialState.siteLogo);
    };

    const onWidthChange = (width) => {
        let newLogoOptions = {
            ...siteLogo,
            width: width,
        };

        dispatch({
            type: "set",
            siteLogo: newLogoOptions,
        });

        sendPostMessage({
            param: "siteLogo",
            data: newLogoOptions,
        });
    };

    return (
        <MediaUpload
            onSelect={(media) => onSelectImage(media)}
            allowedTypes={["image"]}
            value={siteLogo.id}
            render={({ open, getMediaOptions }) => (
                <>

                    { '' !== siteLogo.url && undefined !== siteLogo.url ?
                        <div className="ist-seleced-image" >
                            <div className="ist-remove-logo" onClick={onRemoveImage} title={__('Remove Logo', 'astra-sites')}>
                                <svg xmlns="https://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="#333333">
                                    <path d="M8 0.7L7.3 0L4 3.3L0.7 0L0 0.7L3.3 4L0 7.3L0.7 8L4 4.7L7.3 8L8 7.3L4.7 4L8 0.7Z" fill="#333333" />
                                </svg>
                            </div>
                            <img src={siteLogo.url} />
                            <div className="ist-change-logo" onClick={open}>
                                {__("Change Logo", "astra-sites")}
                            </div>
                        </div>
                        : ''
                    }

                    {
                        '' === siteLogo.url ?
                            <div>
                                <Button className="ist-button ist-button-outline" onClick={open}>
                                    {__("Click to Upload", "astra-sites")}
                                </Button>
                            </div>
                            : ''
                    }

                    {'' !== siteLogo.url ?
                        <>
                            <div className="astra-sites-ai-logo-wrap">
                                {__("Logo Width", "astra-sitess")}
                            </div>
                            <div className="astra-sites-ai-rangecontrol-wrap">
                                <RangeControl
                                    value={siteLogo.width}
                                    min={0}
                                    max={500}
                                    step={1}
                                    onChange={(width) => {
                                        onWidthChange(width);
                                    }}
                                />
                            </div>
                        </>
                        : ''
                    }
                </>
            )}
        />
    );
}

export default MediaUploader;
